















import { Vue, Component, Prop } from 'vue-property-decorator';
import renderMarkdown from '../markdown/markdown';

@Component
export default class PageTitle extends Vue {
  @Prop(String) public title!: string;

  get components() {
    let path = '';
    return this.title.split(':').map(component => {
      path = path === '' ? component : path + ':' + component;
      return {
        component,
        path,
      };
    });
  }
}
